/**
 * @deprecated
 */
export default function ConfirmationDialogView() {
    return {
        view: (vnode) => {
            return [
                m('.row.md-12',
                    m('.card',
                        m('.card-body',
                            m('.col-md-12', m('label', vnode.attrs.text))
                        )
                    )
                ),
            ];
        }
    }
}
